import { Deserializable } from '../deserializable';

export class NamedEntityDto implements Deserializable {
  public Name: string;
  public Id: number;
  public IdAsHash: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
